// extracted by mini-css-extract-plugin
export var tosLink = "_ar-0";